export const FEATURE_AIS = 'featureAIS'
